// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"bd0359ad","624":"83499f6c","989":"c5e79b7e"}[chunkId] + ".chunk.js";
};